// extracted by mini-css-extract-plugin
export default {"tableBorder":"sutdentTable_tableBorder__nhK2Y"};